import { jsPDF } from 'jspdf';

// Sample planetary positions data (replace with actual calculation)
const generateBirthChartPDF = (birthData) => {
  const doc = new jsPDF();

  // Add title
  doc.setFontSize(20);
  doc.setTextColor(102, 126, 234);
  doc.text('Birth Chart Report', 105, 20, { align: 'center' });

  // Add subtitle
  doc.setFontSize(12);
  doc.setTextColor(0, 0, 0);
  doc.text('IVY ASTROLOGY - Discover Your Cosmic Blueprint', 105, 30, { align: 'center' });

  // Add birth data
  doc.setFontSize(10);
  doc.text(`Generated: ${new Date().toLocaleDateString()}`, 105, 40, { align: 'center' });

  // Section: Planetary Positions
  doc.setFontSize(16);
  doc.setTextColor(102, 126, 234);
  doc.text('Planetary Positions & Degrees', 20, 55);

  // Table header
  doc.setFontSize(11);
  doc.setTextColor(0, 0, 0);
  doc.setFont(undefined, 'bold');
  doc.text('Planet', 20, 65);
  doc.text('Sign', 80, 65);
  doc.text('Degree', 130, 65);
  doc.text('House', 170, 65);

  // Draw line under header
  doc.setLineWidth(0.5);
  doc.setDrawColor(102, 126, 234);
  doc.line(20, 67, 190, 67);

  // Planetary data (example - would be replaced with actual calculation)
  const planetaryData = birthData || [
    { planet: '☉ Sun', sign: 'Aries', degree: '15° 23\'', house: '1st' },
    { planet: '☽ Moon', sign: 'Taurus', degree: '8° 47\'', house: '2nd' },
    { planet: '☿ Mercury', sign: 'Aries', degree: '22° 15\'', house: '1st' },
    { planet: '♀ Venus', sign: 'Pisces', degree: '3° 56\'', house: '12th' },
    { planet: '♂ Mars', sign: 'Gemini', degree: '12° 38\'', house: '3rd' },
    { planet: '♃ Jupiter', sign: 'Leo', degree: '27° 09\'', house: '5th' },
    { planet: '♄ Saturn', sign: 'Capricorn', degree: '19° 44\'', house: '10th' },
    { planet: '♅ Uranus', sign: 'Aquarius', degree: '5° 21\'', house: '11th' },
    { planet: '♆ Neptune', sign: 'Pisces', degree: '14° 33\'', house: '12th' },
    { planet: '♇ Pluto', sign: 'Capricorn', degree: '23° 17\'', house: '10th' },
  ];

  // Add Ascendant at the top
  doc.setFont(undefined, 'bold');
  doc.setFontSize(12);
  doc.setTextColor(255, 107, 107);
  doc.text('⬆ Ascendant (Rising Sign)', 20, 75);
  doc.setFont(undefined, 'normal');
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(11);
  doc.text('Aries', 80, 75);
  doc.text('12° 45\'', 130, 75);
  doc.text('1st', 170, 75);

  // Draw line after ascendant
  doc.setLineWidth(0.3);
  doc.setDrawColor(200, 200, 200);
  doc.line(20, 77, 190, 77);

  // Add planetary positions
  doc.setFont(undefined, 'normal');
  let yPosition = 85;

  planetaryData.forEach((item, index) => {
    if (yPosition > 270) {
      doc.addPage();
      yPosition = 20;
    }

    doc.text(item.planet, 20, yPosition);
    doc.text(item.sign, 80, yPosition);
    doc.text(item.degree, 130, yPosition);
    doc.text(item.house, 170, yPosition);

    yPosition += 8;
  });

  // Add aspects section
  yPosition += 10;
  doc.setFontSize(16);
  doc.setTextColor(102, 126, 234);
  doc.text('Major Aspects', 20, yPosition);

  yPosition += 10;
  doc.setFontSize(10);
  doc.setTextColor(0, 0, 0);

  const aspects = [
    { planets: 'Sun ⚹ Moon', type: 'Trine', orb: '3°12\'' },
    { planets: 'Venus ☐ Mars', type: 'Square', orb: '2°45\'' },
    { planets: 'Jupiter ⚹ Neptune', type: 'Trine', orb: '1°28\'' },
    { planets: 'Saturn ☍ Uranus', type: 'Opposition', orb: '4°03\'' },
  ];

  aspects.forEach((aspect) => {
    doc.text(`${aspect.planets} - ${aspect.type} (${aspect.orb})`, 20, yPosition);
    yPosition += 6;
  });

  // Add footer
  doc.setFontSize(8);
  doc.setTextColor(128, 128, 128);
  doc.text('© 2024 IVY ASTROLOGY - For entertainment purposes only', 105, 285, { align: 'center' });
  doc.text('www.ivyastrology.com', 105, 290, { align: 'center' });

  // Save the PDF
  doc.save('birth-chart-report.pdf');
};

export default generateBirthChartPDF;
